import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../../atomic/animations/brand/chevron-scroll.js";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/overlay/modal.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "../../../atomic/text-lockup/date.js";
import "../../../atomic/text-lockup/small.js";
import { createTextLockupSmallScaling } from "../../../atomic/text-lockup/small-scaling.js";
const createCompositeCardOverlayIcon = (props) => {
  const children = [];
  if (props.image) {
    const imageContainer = new ElementBuilder().withClassName("card-overlay-icon-image").withStyles({
      element: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: `${token.spacing.lg}`,
        "& *": {
          maxHeight: "120px"
        }
      }
    }).withChild(props.image).build();
    children.push(imageContainer);
  }
  children.push(
    createTextLockupSmallScaling({
      ...props,
      customStyles: {
        height: "auto"
      }
    })
  );
  return new ElementBuilder().withClassName("card-overlay-icon").withStyles({
    element: {
      containerType: "inline-size",
      height: "100%",
      overflow: "hidden",
      position: "relative",
      padding: `${token.spacing.md}`,
      paddingTop: `${token.spacing.sm}`,
      backgroundColor: token.color.gray.lightest,
      ...props.isThemeDark && {
        backgroundColor: token.color.gray.darker
      }
    }
  }).withChildren(...children).build();
};
export {
  createCompositeCardOverlayIcon
};
//# sourceMappingURL=icon.js.map
